import { FormState, useWatch } from '@vtex/admin-ui-form'
import { useSkusImport } from 'hooks'
import { useIntl } from 'react-intl'
import { LIMITS } from 'shared'
import { Item } from 'typings'
import { SkuSelector } from 'ui'
import { messages } from './messages'
import { GiftKeys } from '../../../typings'

type Props = {
  form: FormState
}

export function GiftSelector(props: Props) {
  const { form } = props

  const { $t } = useIntl()

  const { importSkus, loading: importing } = useSkusImport()

  const items: Item[] = useWatch({ form, name: GiftKeys.items })

  return (
    <SkuSelector>
      <SkuSelector.Header>
        <SkuSelector.Download values={items} />
        <SkuSelector.Upload
          name={GiftKeys.items}
          form={form}
          importer={importSkus}
          maxEntries={LIMITS.MAX_GIFTS}
        />
      </SkuSelector.Header>
      <SkuSelector.Selector
        name={GiftKeys.items}
        placeholder={$t(messages.placeholder)}
        state={form}
        loading={importing}
      />
    </SkuSelector>
  )
}
